import React from 'react';
import cn from 'classname';
import './index.less';
import Row from './row';

function PayoutTable({ table, ...props }) {
	const { rows, headers } = table;
	return (
		<div
			className="table-container payout-requests-risk-table"
		>
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium">
					<tr className="top-affiliates-table-top-row">
						{
							headers
								.map((header, i) =>
									<th
										key={i}
										className={cn({
											[header.className]: !!header.className,
											'active': props.sort.index === header.index,
											[props.sort.direction]: props.sort.index === header.index
										})}
										onClick={props.sortData.bind(null, header.index)}
									>
										{header.title}
									</th>
								)
						}
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{rows.map((row, index) =>
						<Row row={row} key={index} {...props} />
					)}
				</tbody>
			</table>
			<div className="table-container__navigation">
				{ props.isShowMoreVisible && (
					<button className="ui-btn ui-btn-secondary" onClick={props.concatPaginatedData}>
						{props.intl('Show more')}
					</button>
				)}
			</div>
		</div>
	);
}

export default PayoutTable;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-risky/main.js